import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { OCSPResponseStatus } from "./ocsp_response_status";
import { ResponseBytes } from "./response_bytes";
export class OCSPResponse {
    constructor(params = {}) {
        this.responseStatus = OCSPResponseStatus.successful;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Enumerated })
], OCSPResponse.prototype, "responseStatus", void 0);
__decorate([
    AsnProp({ type: ResponseBytes, context: 0, optional: true })
], OCSPResponse.prototype, "responseBytes", void 0);
